import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Route, Link } from 'react-router-dom';
import { actions } from 'react-redux-form';
import { Alert, Button } from 'react-bootstrap';
import { fetchLoginState, failFetchingLoginState } from '../actions/auth';
import { fetchYear } from '../actions/year';
import { getDayProgressSummary } from '../actions/user-data';
import {
  fetchQuestionList,
  fetchUpdateQuestionList,
} from '../actions/question';
import { fetchInformationList } from '../actions/information';
import { fetchEventList } from '../actions/event';
import Header from '../components/layout/Header';
import Footer from '../components/layout/Footer';
import Loading from '../components/Loading';
import moment from 'moment';
import { updateUserData, uploadUserData } from '../modules/common';
import appEventHandler, { AppEvents } from '../modules/storeMountCheck';
import { isIE } from 'react-device-detect';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { LoadingOverlay } from '../components/Loader';

class Container extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isExitConfirm: false,
      uploadAttemptTime: null,
      showUploadWarning: false,
      isSyncing: false,
    };
    this.handleUploadAttempt = this.handleUploadAttempt.bind(this);
    this.handleSyncNow = this.handleSyncNow.bind(this);
  }
  componentDidMount() {
    const { forms, global, dispatch, auth, question, location } = this.props;
    const path = location.pathname || '/';
    if (path.match(/\/nologin/)) {
      return;
    }
    if (forms.global.newSearchMode == null) {
      dispatch(actions.change('forms.global.searchMode', '3'));
      dispatch(actions.change('forms.global.newSearchMode', true));
    }

    dispatch(fetchYear());
    if (!auth.isPrepared) {
      console.log('no login');
      if (window.navigator.onLine) {
        dispatch(fetchLoginState());
      } else {
        localStorage.removeItem('jwt');
        console.log('offine logout');
        dispatch(failFetchingLoginState());
      }
    }
    if (!question.isPrepared) {
      dispatch(fetchQuestionList());
      dispatch(
        actions.change('forms.global.lastFetchTime', global.lastFetchTime)
      );
    } else {
      let lastFetchTime;
      if (!forms.global.lastFetchTime) {
        lastFetchTime = global.lastFetchTime;
      } else {
        if (
          forms.global.lastFetchTime.match(/^undefined/) ||
          moment(forms.global.lastFetchTime).isBefore(global.lastFetchTime) ||
          forms.global.dbVersion == null ||
          forms.global.dbVersion < global.dbVersion
        ) {
          dispatch(
            fetchQuestionList(),
            dispatch(
              fetchUpdateQuestionList({ lastFetchTime: global.lastFetchTime })
            )
          );
          if (forms.global.dbVersion == null) {
            console.log('dbVersiion is null.');
          }
          if (forms.global.dbVersion < global.dbVersion) {
            console.log('dbVersion updated.');
          }
          console.log('question list all updates.');
          dispatch(actions.change('forms.global.dbVersion', global.dbVersion));
        } else {
          lastFetchTime = forms.global.lastFetchTime;
          dispatch(fetchUpdateQuestionList({ lastFetchTime: lastFetchTime }));
        }
      }
    }
    if (forms.global && forms.global.fontSize) {
      document.body.style.fontSize = forms.global.fontSize;
    }
    updateUserData(auth, global, forms);
    dispatch(fetchInformationList());
    dispatch(fetchEventList());
    dispatch(getDayProgressSummary());
    this.updateQuestionInterval = setInterval(
      () => dispatch(fetchUpdateQuestionList()),
      6 * 60 * 60 * 1000
    );
    this.updateInformationInterval = setInterval(
      () => dispatch(fetchInformationList()),
      6 * 60 * 60 * 1000
    );
    this.updateYearInterval = setInterval(
      () => dispatch(fetchYear()),
      1 * 60 * 60 * 1000
    );
    this.updateUserDataInterval = setInterval(
      () =>
        updateUserData(this.props.auth, this.props.global, this.props.forms),
      60 * 1000
    );
    this.updateEventInterval = setInterval(
      () => dispatch(fetchEventList()),
      6 * 60 * 60 * 1000
    );
    this.updateProgressSummaryInterval = setInterval(
      () => dispatch(getDayProgressSummary()),
      6 * 60 * 60 * 1000
    );

    appEventHandler.on(AppEvents.UPLOAD_ATTEMPT, this.handleUploadAttempt);

    this.checkUploadStatusInterval = setInterval(() => {
      if (this.state.uploadAttemptTime) {
        const diff = moment().diff(this.state.uploadAttemptTime, 'minutes');
        if (diff >= 10) {
          this.setState({ showUploadWarning: true });
        }
      }
    }, 60 * 1000);
  }
  componentWillUnmount() {
    const { auth, userData, location } = this.props;
    const path = location.pathname || '/';
    if (path.match(/\/nologin/)) {
      return;
    }

    if (auth.user && window.navigator.onLine) {
      uploadUserData(auth.user, userData).catch((error) => {
        console.error('Unmount sync failed:', error);
      });
    }
    clearInterval(this.updateQuestionInterval);
    clearInterval(this.updateInformationInterval);
    clearInterval(this.updateYearInterval);
    clearInterval(this.updateUserDataInterval);
    clearInterval(this.updateEventInterval);
    clearInterval(this.updateProgressSummaryInterval);
    appEventHandler.removeListener(
      AppEvents.UPLOAD_ATTEMPT,
      this.handleUploadAttempt
    );
    clearInterval(this.checkUploadStatusInterval);
  }
  UNSAFE_componentWillReceiveProps(nextProps) {
    const { forms, userData } = this.props;
    const nextFontSize = nextProps.forms.global.fontSize;
    if (forms.global && forms.global.fontSize !== nextFontSize) {
      document.body.style.fontSize = nextFontSize;
    }
    // lastUpdateが更新されたらアップロード成功とみなす
    if (userData.lastUpdate !== nextProps.userData.lastUpdate) {
      this.setState({
        uploadAttemptTime: null,
        showUploadWarning: false,
      });
    }
  }

  handleUploadAttempt() {
    // 既に試行中の場合は更新しない
    if (!this.state.uploadAttemptTime) {
      this.setState({ uploadAttemptTime: moment() });
    }
  }

  handleSyncNow = async () => {
    if (this.state.isSyncing) {
      return;
    }

    const { auth, userData } = this.props;
    if (!auth.user) {
      return;
    }

    this.setState({ isSyncing: true });
    try {
      await uploadUserData(auth.user, userData);
      toast.success('データの同期を試みました。');
    } catch (error) {
      if (String(error) === 'Error: offline') {
        toast.warn('オフラインのため同期できません。');
      } else {
        toast.error(
          '同期に失敗しました。しばらくしてからもう一度お試しください。'
        );
      }
      console.error('Manual sync failed:', error);
    } finally {
      this.setState({ isSyncing: false });
    }
  };

  render() {
    const { children, question, forms, auth, location, year } = this.props;
    const path = location.pathname || '/';
    if (path.match(/\/nologin/)) {
      return (
        <div id="wrap-container">
          <div id="wrap-main">
            <Route children={children} />
          </div>
        </div>
      );
    }
    if (!auth.isPrepared) {
      return <Loading />;
    }
    if (!question) {
      return <Loading />;
    }
    if (!year || !year.data) {
      return <Loading />;
    }
    if (isIE) {
      return (
        <span>
          お使いのブラウザ(Internet Exploler)では動作しません。最新版の
          <a href="https://www.google.com/chrome/">Google Chrome</a>
          をお使い下さい。
        </span>
      );
    }

    return (
      <div id="wrap-container">
        <Header
          isWhileUpdate={forms.isWhileUpdate}
          showUploadWarning={this.state.showUploadWarning}
        />
        {!auth.user ? (
          <Alert bsStyle="danger" className="lead" style={{ marginBottom: 0 }}>
            {year.data.noLoginFlag ? (
              <span
                dangerouslySetInnerHTML={{
                  __html: year.data.noLoginMessage,
                }}
              />
            ) : (
              <span>
                今年版の合格ロケットが未購入のため試用版が表示されています。今年版を購入後
                <Link to="/mypage/">ログイン</Link>
                すると全ての機能が利用できます
                {year.data.settingYear !== year.data.year && (
                  <span>
                    ({year.data.settingYear}
                    年版アプリの利用は11月上旬から可能になります)
                  </span>
                )}
                。
              </span>
            )}
          </Alert>
        ) : (
          <React.Fragment>
            {!auth.user.buyFlag && !path.match(/\/order/) ? (
              <Alert
                bsStyle="danger"
                className="lead"
                style={{ marginBottom: 0 }}
              >
                今年版の合格ロケットが未購入のため試用版が表示されています。
                <Link to="/order">今年版を購入</Link>
                すると全ての機能を利用できます
                {year.data.settingYear !== year.data.year && (
                  <span>
                    ({year.data.settingYear}
                    年版アプリの利用は11月上旬から可能になります)
                  </span>
                )}
                。
              </Alert>
            ) : (
              <React.Fragment>
                {auth.user.preUse && (
                  <Alert
                    bsStyle="danger"
                    className="lead"
                    style={{ marginBottom: 0 }}
                  >
                    利用開始可能日前のため、試用版が表示されています
                    {year.data.settingYear !== year.data.year && (
                      <span>
                        ({year.data.settingYear}
                        年版アプリの利用は11月上旬から可能になります)
                      </span>
                    )}
                    。
                  </Alert>
                )}
              </React.Fragment>
            )}
          </React.Fragment>
        )}
        <div
          id="wrap-main"
          style={{ backgroundColor: forms.layout.backgroundColor }}
        >
          <Route children={children} />
        </div>
        <Footer />
        <LoadingOverlay style={{ marginTop: 60 }} spinner={<Loading />} />
        <ToastContainer />
      </div>
    );
  }
}

Container.propTypes = {
  dispatch: PropTypes.func.isRequired,
  children: PropTypes.object.isRequired,
};

export default connect((s) => s)(Container);



// WEBPACK FOOTER //
// ./src/containers/container.js